export default {
  convertTimeToSEC(fieldValue: number, selectedOption: 'MIN' | 'HRS' | 'SEC') {
    switch (selectedOption) {
      case 'MIN':
        return +(+fieldValue * 60).toFixed(0);
      case 'HRS':
        return +(+fieldValue * 3600).toFixed(0);
      case 'SEC':
        return +(+fieldValue).toFixed(0);
      default:
        return +fieldValue;
    }
  },
  convertSizeToMB(fieldValue: number, selectedOption: 'MB' | 'GB' | 'TB') {
    if (selectedOption === 'MB') return Number(Number(fieldValue).toFixed(0));
    if (selectedOption === 'GB') return Number((Number(fieldValue) * 1024).toFixed(0));
    if (selectedOption === 'TB') return Number((Number(fieldValue) * 1024 * 1024).toFixed(0));
    return Number(String(fieldValue).replace(/\D/g, '')); // unknown convertor
  },
  convertTimeToDays(fieldValue: number, selectedOption: 'MON' | 'DAYS') {
    switch (selectedOption) {
      case 'MON':
        return +fieldValue * 30;
      case 'DAYS':
      default:
        return fieldValue;
    }
  },
};

export const refreshPageAfterUIPortChange = (updatedPort: number | undefined) => {
  const { protocol, hostname, pathname } = new URL(window.location.href);
  const win = window.open(`${protocol}//${hostname}:${updatedPort}${pathname}`, '_blank');
  win?.focus();
};
